<template>
  <div>
    <text-cell v-if="value.type === 'TEXT'" :use-lexicon="value.useLexicon" :value="value.value"/>

    <currency-cell v-if="value.type === 'CURRENCY'" :value="Number(value.value)"/>

    <number-value-cell v-if="value.type === 'RATIO' || value.type === 'COUNT'" :no-digits="value.type === 'COUNT'"
                       :value="Number(value.value)"/>

    <percentage-cell v-if="value.type === 'PERCENT'" :no-sign="false" :value="Number(value.value)"/>
  </div>
</template>

<script>
import TextCell from "@/components/common/DataTable/CellComponents/TextCell"
import CurrencyCell from "@/components/common/DataTable/CellComponents/CurrencyCell"
import NumberValueCell from "@/components/common/DataTable/CellComponents/NumberValueCell"
import PercentageCell from "@/components/common/DataTable/CellComponents/PercentageCell"

export default {
  name: "DynamicRendererCell",
  components: {PercentageCell, NumberValueCell, CurrencyCell, TextCell},
  props: {
    /** object containing type + value attributes */
    value: {}
  },
}
</script>

<style scoped>

</style>
